import React from "react";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import { GetExamSettingsAuditFilters, GetExamSettingsAuditTrails } from "../../../../services/ExternalExamServices";
import AuditTrailsTable from "../../../common/AuditTrailsTable";

function ExamSettingAuditTrail() {
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  usePermissionGuardRedirect(['eeesview']);

  return (
    <AuditTrailsTable 
      apiFunction={GetExamSettingsAuditTrails}
      filterArrApi={GetExamSettingsAuditFilters}
      columnsToShow={columnsToShow}
      exportFileName={"Exam_Settings_Audit_Trail"}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      // apiParams={{action_id: subTab}}
      // actionId={subTab}
    />
  );
}

export default ExamSettingAuditTrail;
